/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Send_App_DescInputs */

const en_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tailor and apply`)
};

const de_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassen und bewerben`)
};

const fr_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnaliser et postuler`)
};

const es_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizar y postularse`)
};

const it_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizza e candidati`)
};

const nl_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas aan en solliciteer`)
};

const pl_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosuj i aplikuj`)
};

const fi_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mukauta ja lähetä`)
};

const da_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilpas og ansøg`)
};

const sv_dashboard_step_send_app_desc = /** @type {(inputs: Dashboard_Step_Send_App_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassa och ansök`)
};

/**
* | output |
* | --- |
* | "Tailor and apply" |
*
* @param {Dashboard_Step_Send_App_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_send_app_desc = /** @type {((inputs?: Dashboard_Step_Send_App_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Send_App_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_send_app_desc(inputs)
	if (locale === "fr") return fr_dashboard_step_send_app_desc(inputs)
	if (locale === "es") return es_dashboard_step_send_app_desc(inputs)
	if (locale === "it") return it_dashboard_step_send_app_desc(inputs)
	if (locale === "nl") return nl_dashboard_step_send_app_desc(inputs)
	if (locale === "pl") return pl_dashboard_step_send_app_desc(inputs)
	if (locale === "fi") return fi_dashboard_step_send_app_desc(inputs)
	if (locale === "da") return da_dashboard_step_send_app_desc(inputs)
	if (locale === "sv") return sv_dashboard_step_send_app_desc(inputs)
	return en_dashboard_step_send_app_desc(inputs)
});